import { render, staticRenderFns } from "./Article_manage.vue?vue&type=template&id=35d41d4e&scoped=true&"
import script from "./Article_manage.vue?vue&type=script&lang=js&"
export * from "./Article_manage.vue?vue&type=script&lang=js&"
import style0 from "./Article_manage.vue?vue&type=style&index=0&id=35d41d4e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d41d4e",
  null
  
)

export default component.exports